var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g886",
    transform: "matrix(0.99965074,0,0,1.0002548,4.5158207e-5,-4.4586968e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12906",
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.296737,
      strokeLinecap: "square"
    },
    d: "M 0.14939266,0.14747725 H 5.1460815 V 6.4636761 H 0.14939266 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12936",
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.291006,
      strokeLinecap: "square"
    },
    d: "M 3.8922578,4.0254245 A 1.3897258,1.4053758 0 0 1 2.502532,5.4308003 1.3897258,1.4053758 0 0 1 1.1128062,4.0254245 1.3897258,1.4053758 0 0 1 2.502532,2.6200486 1.3897258,1.4053758 0 0 1 3.8922578,4.0254245 Z"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "i",
    transform: "scale(0.9944164,1.005615)",
    id: "text14710",
    style: {
      fontSize: "2.94951px",
      lineHeight: 1.25,
      fontFamily: "'High Tower Text'",
      InkscapeFontSpecification: "'High Tower Text, Normal'",
      fill: "#343434",
      strokeWidth: 0.0737372
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 2.6811199,3.2306799 q 0,0.066249 -0.050407,0.1238564 -0.048967,0.056167 -0.1080143,0.056167 -0.067689,0 -0.1108947,-0.040325 -0.043206,-0.040325 -0.043206,-0.1051339 0,-0.063368 0.051847,-0.1180956 0.053287,-0.054727 0.113775,-0.054727 0.1468995,0 0.1469,0.1382581 z M 2.840981,4.8609755 q -0.0072,0.041765 -0.034565,0.047526 -0.0072,0.00144 -0.069129,-0.00288 -0.2145884,-0.014402 -0.4219758,0.00576 -0.056167,0.00576 -0.070569,-0.00432 -0.014402,-0.010081 -0.014402,-0.046086 0,-0.033124 0.07633,-0.054727 0.083531,-0.024483 0.083531,-0.1598612 V 4.2690572 q 0,-0.113775 -0.023043,-0.1598611 -0.031684,-0.063368 -0.1310573,-0.096493 -0.044646,-0.015842 -0.044646,-0.047526 0,-0.041766 0.064809,-0.061928 0.120976,-0.037445 0.2145883,-0.099373 0.07489,-0.051847 0.092172,-0.051847 0.057608,0 0.056167,0.07489 -0.00576,0.3773299 -0.00576,0.7690617 0,0.093612 0.027364,0.1339377 0.030244,0.044646 0.1152153,0.063368 0.093612,0.021603 0.084971,0.067689 z",
    id: "path836"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOff);
export default __webpack_public_path__ + "static/media/info_off.8a027bbb37d0e75975a6eac476679279.svg";
export { ForwardRef as ReactComponent };